import {
  Network,
  Network as NetworkProtected,
  PartnerDetails as PartnerDetailsProtected,
} from 'api';
import { Network as NetworkPublic, PartnerDetails as PartnerDetailsPublic } from 'api/public';
import { cloneDeep } from 'lodash';

import { queryString } from 'utilities';

import { PARTNER_SHARE_NETWORKS_KEY } from './constants';
import { Share } from './types';

export function addNetwork(network: NetworkPublic | NetworkProtected) {
  const current = localStorage.getItem(PARTNER_SHARE_NETWORKS_KEY);

  if (!current) {
    localStorage.setItem(PARTNER_SHARE_NETWORKS_KEY, network);
    return;
  }

  if (current.includes(network)) {
    return;
  }

  const next = `${current},${network}`;
  localStorage.setItem(PARTNER_SHARE_NETWORKS_KEY, next);
}

export function removeNetwork(network: NetworkPublic | NetworkProtected) {
  const current = localStorage.getItem(PARTNER_SHARE_NETWORKS_KEY);

  if (!current) {
    return;
  }

  if (!current.includes(network)) {
    return;
  }

  const next = current.replace(network, '').replace(/,\s*$/, '');
  localStorage.setItem(PARTNER_SHARE_NETWORKS_KEY, next);
}

export function partnerRedirect(redirectUrl: string) {
  const networks = localStorage.getItem(PARTNER_SHARE_NETWORKS_KEY) || '';
  const params = {
    networks,
    state: 'success',
    time: Math.round(Date.now() / 1000),
  };

  localStorage.removeItem(PARTNER_SHARE_NETWORKS_KEY);
  window.location.href = `${encodeURI(redirectUrl)}?${queryString(params)}`;
}

export function partnerRedirectError(redirectUrl: string, reason: string) {
  window.location.href = `${encodeURI(redirectUrl)}?state=error&error_message=${reason}`;
}

export function prepShareItems(formValues: Share) {
  let hasFacebook = false;

  const clonedItems = cloneDeep(formValues.items);
  const filteredItems = clonedItems
    .filter(item => item.state.active)
    .filter(item => {
      if (item.state.networkMeta.provider === Network.Twitter) {
        addNetwork(Network.Twitter);
        return true;
      }

      if (item.state.networkMeta.provider === Network.Linkedin) {
        addNetwork(Network.Linkedin);
        return true;
      }

      if (item.state.networkMeta.provider === Network.Facebook) {
        addNetwork(Network.Facebook);
        hasFacebook = true;
        return true;
      }

      return false;
    });

  filteredItems.forEach(item => delete item.state);

  return { items: filteredItems, hasFacebook };
}

export function getRedirectUrl(partnerDetails: PartnerDetailsPublic | PartnerDetailsProtected) {
  const searchParams = new URLSearchParams(window.location.search);
  const redirectUrl = searchParams.get('redirect_uri');
  const validatedPartnerUrl = partnerDetails.redirect_uris.find(uri => uri === redirectUrl);

  return validatedPartnerUrl || '';
}
